export default function ContractSCU({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
  return (
    <>
<div className="container mb100 mt100">
  <div className="beckertitlename mb100 mt100">Becker 學分班方案</div>
  <div className="card w-75 p-5 m-auto">
    <h5 className="card-title text-black text-center">Becker CSU 學分班方案購買須知與同意事項（請務必詳閱）</h5>
    <div className="br mb-5 mt-3"></div>
    <div className="card-body">
      <div className="card-text m-auto">
        <ol className="contract-main-list">
          <li>
            <strong>訂購程序、審閱期與契約成立</strong>
            <ol>
              <li>
                <strong>訂購程序</strong>
                <ol>
                  <li>購買方案者，須填妥本訂購單資料表，完整審閱本購買須知與相關規定後，完成付費，方符合訂購程序。</li>
                  <li>繳費前，請先確認購買產品內容、方案項目、費用及相關使用限制。</li>
                </ol>
              </li>
              <li>
                <strong>審閱期與購買者資格</strong>
                <ol>
                  <li>購買前請確認已完整審閱本購買須知與相關規定，審閱期已達五日。</li>
                  <li>購買方案者保證為完全行為能力人，或為已得法定代理人同意之限制行為能力人。</li>
                </ol>
              </li>
              <li>
                <strong>契約成立與電子簽名</strong>
                <ol>
                  <li>購買者於本線上報名及訂購流程中勾選「同意」並完成購買程序時，即表示已完整審閱並確認同意本契約全部條款內容。</li>
                  <li>購買者同意以系統依其所填載之中文姓名自動產生之電子簽名（屬電子形式之姓名印記，非本人親筆簽名）作為本人簽名及用印之正式意思表示。</li>
                  <li>購買者確認該電子簽名係其真意表示，並同意不得以非親筆簽名或電子形式為由否認其法律效力。系統並將依該電子簽名自動生成並成立本購買契約書，其效力與經購買者親筆簽名之書面契約相同，對雙方均具法律拘束力。</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <strong>報名資格、方案性質與適用限制</strong>
            <ol>
              <li>
                <strong>方案性質</strong>
                <ol>
                  <li>本學分班為 Becker Taiwan（捷進）美國註冊會計師系列方案之附加產品。</li>
                  <li>本學分班使用美國 Becker Professional Education 進口原版教材授課，課程內容受美國聯邦政府智慧財產權法與中華民國政府經濟部智慧財產權法保護。</li>
                  <li>本學分班課程使用 Becker CPA Exam Review 與 Becker CPA Final Review 教材內容，其使用效期、準則、方式皆依照「Becker CPA 方案購買須知與同意事項」所列為準。</li>
                </ol>
              </li>
              <li>
                <strong>報名資格</strong>
                <ol>
                  <li>報名者須於報名學分班時，已購買 Becker Taiwan（捷進）美國註冊會計師「專業方案」或「全修方案」、或持有充足之線上中文課程使用額度，且該方案仍在使用效期內。</li>
                  <li>所報名之學分班學期結束日，不得晚於個人 Becker 所購方案使用效期到期日。</li>
                  <li>學分班一門課為 3 學分。學員得於購買 Becker Taiwan（捷進）販售之美國註冊會計師系列方案中含有中文課程（正課）之方案後，完成學分班課程，並於課後測驗及格後，申請學分成績。</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <strong>學分班課程、測驗與學分申請</strong>
            <ol>
              <li>
                <strong>課程與服務使用期限</strong>
                <ol>
                  <li>學分班中可使用相關之中文線上課程、協助參加課後測驗、申請註冊 CSUEB 學分成績等加值服務，其有效期限與學員個人軟體效期一致。</li>
                  <li>學員使用效期結束時，若未使用完畢學分班各類型課程時數，剩餘時數等同失效，學員不得異議。</li>
                </ol>
              </li>
              <li>
                <strong>開課日期與學分申請截止日</strong>
                <ol>
                  <li>學分班開課日期與完課申請學分證明之截止日期，依 Becker Taiwan 於官網（www.beckertw.com）公告之課表為準。</li>
                  <li>學分班測驗評量方式依加州州立大學東灣分校（CSUEB）規定，並顯示於 Becker Taiwan 於官網（www.beckertw.com）公告之各門課程大綱內。</li>
                </ol>
              </li>
              <li>
                <strong>課後測驗與考試安排</strong>
                <ol>
                  <li>課後測驗於線上考試系統進行。</li>
                  <li>期末考，學員可選擇線上考試或現場考試。</li>
                  <li>現場考試位於 Becker Taiwan 辦公室空間，需要事先預約並獲得確認，考試安排不收費。</li>
                  <li>若選擇線上考試，線上考試暨監考服務係透過第三方線上考試平台 ExamRoom.AI 提供，學員於預約考試時自行線上支付線上考試費用給該平台。</li>
                  <li>學分班產品不含線上考試報名費，單次測驗所需費用依線上考試系統公告為準，由學員於報名測驗時，直接向該系統單位付費。</li>
                  <li>若因第三方線上考試平台之系統維護、服務中斷、連線異常、平台功能調整或其他非可歸責於 Becker Taiwan（捷進）之事由，致學員暫時無法進行線上考試，Becker Taiwan（捷進）將提供必要協助並協調恢復服務，惟不負因此所生之損害賠償責任。</li>
                </ol>
              </li>
              <li>
                <strong>學分成績申請</strong>
                <ol>
                  <li>Becker Taiwan（捷進）針對於所選學期內完成課程與測驗之學員，協助向 CSUEB 申請註冊學分成績、發送成績結果通知。</li>
                  <li>學分成績之申請、註冊與結果，仍應依 CSUEB 相關規定與審查結果為準。</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <strong>中文線上課程與加值服務使用規範</strong>
            <ol>
              <li>
                <strong>中文線上課程使用原則</strong>
                <ol>
                  <li>學分班中可使用相關中文課程為線上課程，學員參加後不得要求變更、轉讓以及重複行使權益。</li>
                  <li>Becker Taiwan（捷進）保有線上課程開課（上架）日期之決定權，依各期實際開課公告認定，學員不得異議。</li>
                  <li>使用線上課程時，不得針對內容進行任何錄音、錄影等側錄行為。</li>
                </ol>
              </li>
              <li>
                <strong>加值服務與平台資源</strong>
                <ol>
                  <li>Becker Taiwan（捷進）保有各項加值服務與線上課程平台流量分配之決定權。</li>
                  <li>學員若需使用相關課程、測驗協助、學分申請協助或其他加值服務，應配合 Becker Taiwan（捷進）公告或通知之流程、期限與作業方式辦理。</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <strong>退費標準</strong>
            <ol>
              <li>因故未能開班上課，全額退還已繳之報名費用。</li>
              <li>學員完成報名繳費後，倘因個人因素無法上課時，依下列標準退還報名費用：
                <ul>
                  <li>學員自報名繳費後至實際上課日前退費者，退還已繳報名費之九成。</li>
                  <li>自實際上課日起未逾全期三分之一者，退還學費、雜費等各項費用之半數。</li>
                  <li>若已逾所選課程全長三分之一者，不予退還。</li>
                </ul>
              </li>
            </ol>
          </li>
          <li>
            <strong>帳號、授權與通訊管理</strong>
            <ol>
              <li>
                <strong>帳號與登入管理</strong>
                <ol>
                  <li>學員領取帳號後，應妥善保管其登入密碼，確保不為他人得知。</li>
                  <li>利用學員帳號密碼登入學習帳號，將推定為學員本人之行為。</li>
                  <li>因非可歸責於 Becker Taiwan（捷進）之事由導致登入密碼外洩時，學員應儘速通知；Becker Taiwan（捷進）除提供必要協助外，不負任何法律上責任。</li>
                  <li>為提升服務品質及確保學員正確使用本教材與課程影片，Becker Professional Education 與 Becker Taiwan（捷進）將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址（IP address）等相關資訊。在任何情況下，系統若發現有多人登錄同一帳號情況，Becker Taiwan（捷進）有權中止該帳號之課程使用權限。</li>
                </ol>
              </li>
              <li>
                <strong>個人使用限制</strong>
                <ol>
                  <li>本學分班課程、教材、影片、測驗及相關服務均限購買者個人使用與參加，不得轉贈、轉讓及分享。</li>
                  <li>學員應依 Becker Taiwan（捷進）、Becker Professional Education 及相關課程平台之使用規範使用本學分班產品與服務。</li>
                </ol>
              </li>
              <li>
                <strong>E-mail 通訊義務</strong>
                <ol>
                  <li>學員所提供之 E-mail 必須有效期達 24 個月以上。</li>
                  <li>所有帳號通知、課程資訊、系統更新皆以該信箱為唯一正式聯絡方式。</li>
                  <li>購買後請自行定期收信。若因未定期查收郵件而錯過通知，或導致相關權益受影響，學員應自負相關責任。</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <strong>使用設備與連線需求</strong>
            <ol>
              <li>
                <strong>基本設備與系統需求</strong>
                <ol>
                  <li>使用本服務應具備下列軟硬體設備基本規格及要求：
                    <ul>
                      <li>Windows PC/NB：Windows 7 以上</li>
                      <li>Apple PC/NB：macOS 10 以上</li>
                      <li>Apple 行動裝置：iOS 13.0 以上</li>
                      <li>Android 行動裝置：Android 8.0 以上</li>
                      <li>行動裝置限定使用 APP 版觀看課程</li>
                      <li>連線需求：寬頻網路下載速度 20Mbps 以上</li>
                    </ul>
                  </li>
                </ol>
              </li>
              <li>
                <strong>網路使用建議</strong>
                <ol>
                  <li>不建議使用無線、社區型、有線電視台網路、公共免費網路，可能造成無法正常驗證登入或個人帳號密碼資料外洩。</li>
                  <li>其餘未列示之軟硬體或系統，恕不保證其觀看學習品質。</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <strong>個人資料保護與隱私權聲明</strong>
            <ol>
              <li>
                <strong>蒐集、處理及利用目的</strong>
                <ol>
                  <li>Becker Taiwan（捷進）基於本訂購單履約之目的，蒐集、處理並利用您的個人資料。本公司將依個人資料保護法第 8 條第 1 項之要求，向您告知以下事項。</li>
                  <li>蒐集目的：依照 101 年 10 月 1 日修正之個人資料保護法之特定目的及個人資料之類別，040 行銷、069 契約、類似契約或其他法律關係事務、090 消費者客戶管理與服務、157 調查、統計與研究分析、181 其他經營合於營業登記項目或組織章程所定之業務、182 其他諮詢與顧問服務。</li>
                </ol>
              </li>
              <li>
                <strong>個人資料類別</strong>
                <ol>
                  <li>C001 電子郵件、中文姓名、英文拼音全名、電話號碼。</li>
                  <li>C002 金融機構帳戶號碼與姓名。</li>
                  <li>C003 身分證字號。</li>
                  <li>C036 是否曾訂購本公司產品、得知本公司之管道。</li>
                  <li>C038 在職身分。</li>
                  <li>C051 所屬或畢業學校與科系。</li>
                </ol>
              </li>
              <li>
                <strong>個人資料利用期間、地區、對象及方法</strong>
                <ol>
                  <li>本公司會於契約履行、學員服務、帳務處理、法令保存期間及爭議處理所必要期間內利用您的個人資料。</li>
                  <li>利用地區包含中華民國境內及 Becker 原廠帳號開通、服務提供所必要之境外地區。</li>
                  <li>本公司將會依照您所填寫之訂購資料，確認您已完成訂購，並替您註冊帳號、寄送商品、提供學員管理、行銷活動等服務。</li>
                  <li>本公司並將分析您提供之類別 C036、C038、C051 等資訊，以增進本公司之服務。</li>
                  <li>除為履行本契約、開通 Becker 原廠帳號、寄送商品、金流／物流／系統服務所必要，或依法令要求外，在未經您的同意下，我們不會任意將您的個人資料提供給第三人或作不當利用。</li>
                </ol>
              </li>
              <li>
                <strong>個資不完整之影響與權利行使</strong>
                <ol>
                  <li>如您所提供之個人資料不正確或不完整，可能將無法完整履行訂購單內容。</li>
                  <li>您得行使個資法第 3 條所賦予之相關權利，如您欲行使該權利請來信 service@beckertw.com。</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <strong>付費購買與匯款資訊</strong>
            <ol>
              <li>
                <strong>在台購買</strong>
                <table className="contract-table" border="1" cellSpacing="0" cellPadding="8" width="100%" style={{ borderCollapse: "collapse", marginTop: "10px", marginBottom: "15px" }}>
                  <tbody>
                    <tr>
                      <th style={{ width: "30%", textAlign: "left", background: "#f5f5f5" }}>項目</th>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>匯款資訊</th>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>收款人戶名</th>
                      <td>捷進顧問有限公司</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>受款銀行</th>
                      <td>華南商業銀行信維分行（代碼：008）</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>收款人帳號</th>
                      <td>149-10-010062-0</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>匯款金額</th>
                      <td>以新台幣付費，依各方案價格計算。</td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <li>
                <strong>海外購買</strong>
                <table className="contract-table" border="1" cellSpacing="0" cellPadding="8" width="100%" style={{ borderCollapse: "collapse", marginTop: "10px", marginBottom: "15px" }}>
                  <tbody>
                    <tr>
                      <th style={{ width: "30%", textAlign: "left", background: "#f5f5f5" }}>項目</th>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>匯款資訊</th>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>Recipient Name</th>
                      <td>Direct Line Consulting Co.</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>Account Number</th>
                      <td>149-10-010062-0</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>Bank</th>
                      <td>Hua Nan Commercial Bank Ltd.</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>Branch</th>
                      <td>Hsin-Wei Branch</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>SWIFT Code（Bank ID）</th>
                      <td>HNBKTWTP149</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>Bank Address</th>
                      <td>2F, No. 6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City, Taiwan</td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "left", background: "#f5f5f5" }}>匯款金額</th>
                      <td>以新台幣付費，依各方案價格計算。相關中轉行手續費計算方式請向您的支付銀行確認；若無法估算，請直接另附新台幣 200 元之中轉行手續費。</td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ol>
          </li>
          <li>
            <strong>報考資格與官方審查聲明</strong>
            <ol>
              <li>購買者之報考資格應以考試指定之認證機構以及報名審查官方機構出具之審查結果為準。</li>
              <li>Becker Taiwan（捷進）所提供之報考建議或流程說明，僅供參考，不取代任何官方機構之審查或裁定。</li>
            </ol>
          </li>
          <li>
            <strong>教材供應與變更聲明</strong>
            <ol>
              <li>賣方保留任何因賣方代理原廠停產因素而停止供貨的權利。</li>
              <li>賣方亦保留任何因賣方代理原廠更改貨品規格而更改之權利，並對此不負擔責任。</li>
            </ol>
          </li>
          <li>
            <strong>契約終止</strong>
            <ol>
              <li>學員如有違反強制禁止規定或公序良俗之行為，或違反本契約經限期改正仍未改正者，Becker Taiwan（捷進）得終止本契約，學員不得異議。</li>
              <li>如學員自行或因可歸責於己之事由終止契約者，其已繳費用之退還應依本契約第五條「退費標準」辦理；除本契約第五條另有明定、可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，課程、教材一經領取，或帳號開通、登入使用後，學員不得任意要求退費或暫停效期。</li>
            </ol>
          </li>
        </ol>
      </div>

      <div className="text-center">
        <label>
          <input
            className="m-2"
            type="checkbox"
            value="read"
            checked={isChecked}
            onChange={handleCheckboxChange}
            required
          />
          <span>我已詳閱並且了解</span>
        </label>
        <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>下一步</div>
      </div>
    </div>
  </div>
</div>
    </>
  );
}
